/**
 * 클릭하면 그 글자를 클립보드에 복사하고 안내 알림을 띄우는 글자 (2026-09-03).
 *
 *   - 표의 행 클릭(상세 열기) 안에서 쓰이므로 **클릭을 위로 흘리지 않는다**(stopPropagation).
 *   - 글자 길이만큼만 클릭 영역이 되도록 inline 요소로 둔다 — 칸의 빈 자리를 누르면
 *     원래대로 행 동작(상세 열기)이 일어난다.
 *   - 잘려서 「…」로 보이더라도 **복사되는 값은 전체 글자**다.
 */
import { copyWithToast } from '../lib/copy-toast';

export function CopyableText({
  value,
  what,
  className = '',
}: {
  value: string;
  /** 안내 문구에 들어갈 이름 — 예: '프로젝트명' */
  what: string;
  className?: string;
}) {
  if (!value) return null;
  return (
    <span
      className={`cursor-pointer hover:underline hover:text-blue-700 ${className}`}
      title={`${value}\n\n(클릭하면 ${what} 전체가 클립보드에 복사됩니다)`}
      onClick={(e) => {
        e.stopPropagation();
        void copyWithToast(value, what);
      }}
    >
      {value}
    </span>
  );
}
